import React from 'react';

export interface IconHeartProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconHeart: React.FC<IconHeartProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path fillRule="evenodd" clipRule="evenodd" d="M11.9931 5.13581C9.99379 2.7984 6.65975 2.16964 4.15469 4.31001C1.64964 6.45038 1.29697 10.0289 3.2642 12.5605L11.9931 21L20.7221 12.5605C22.6894 10.0289 22.3797 6.42788 19.8316 4.31001C17.2834 2.19216 13.9925 2.7984 11.9931 5.13581Z" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeLinecap="round" />  
    </svg>
  );
};

export default IconHeart;
